/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation PlatformMailer($rateSmtpConfiguration: smtpConfigurationInput!) {
    PlatformMailer(rateSmtpConfiguration: $rateSmtpConfiguration) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
